import type { useClerk } from '@clerk/clerk-react';

/**
 * Saves the workspace just chosen with `setActive` to the session. `setActive` changes it in
 * this tab only; touched, the next load and every other Flobi app open the same workspace, as
 * Home's switch does (Mohamad, 2026-10-07). Call it after `setActive` and before anything
 * reloads or navigates. A failed touch never undoes the switch itself.
 */
export async function touchSession(clerk: ReturnType<typeof useClerk>): Promise<void> {
  try {
    await clerk.session?.touch?.();
  } catch {
    // The switch already happened in this tab; only its persistence is lost.
  }
}
